import { Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators } from "@angular/forms";
import { AlertService } from '../../util/alert/alert.service';
import { LocalStorage } from '../../util/localstorage.service';
import { CommonFunctions } from '../../util/common-functions';
import { User } from 'src/app/models/user.model';
import { Constants } from 'src/app/util/constants';
import { AdminPasscode } from 'src/app/models/admin-passcode.model';
import { PasscodeDataService } from './passcode-data.service';
import { SuperuserPasscode } from 'src/app/models/superuser-passcode.model';

@Component({
  selector: 'app-passcode',
  templateUrl: './passcode.component.html',
  styleUrls: ['./passcode.component.scss']
})
export class PasscodeComponent implements OnInit {

  public paddingtop: number = 160;
  public iSForm: FormGroup;
  public loggedUser: User
  public user:User;

  //fields for admin user
  public adminpasscodemodel:AdminPasscode;
  public adminpasscodeid
  public adminpasscode
  public clinicid

  //fields for super user
  public superuserpasscodemodel:SuperuserPasscode;
  public superuserpasscode

  public updatedby
  public updatedon
  public isAdminUserPasscode: boolean

  constructor(private router: Router, private formBuilder: FormBuilder,private alertService: AlertService,
    private passcodeService: PasscodeDataService) {}

  ngOnInit(): void {
    this.isAdminUserPasscode = false
    this.intializePasscodeDetails()
    this.loggedUser   = JSON.parse(localStorage.getItem(LocalStorage.LOGGED_USER)) as User; 
		if (this.loggedUser.UserRoleID == Constants.UserRoleID.AdminUser) {
      this.getAdminpasscode()
      this.isAdminUserPasscode = true
		}else if(this.loggedUser.UserRoleID == Constants.UserRoleID.SuperUser){
      this.getSuperuserpasscode()
      this.isAdminUserPasscode = false
    }
    
    this.iSForm = this.formBuilder.group({
      adminpasscodeid: new FormControl(null),
      adminpasscode: new FormControl(null),
      superuserpasscode: new FormControl(null),
      clinicid: new FormControl(null),
      updatedby: new FormControl(null),
      updatedon: new FormControl(null)
    } ); 
  }

  intializePasscodeDetails()
  { 
    this.adminpasscodeid = ""
    this.clinicid = ""
    this.adminpasscode = ""
    this.superuserpasscode = ""
    this.updatedby = ""
    this.updatedon = ""
  }

//#region admin passcode related methods
  getAdminpasscode()
	{
    this.alertService.clear()
    this.passcodeService.getAdminPasscodeByClinicID(this.loggedUser.ClinicID, this.loggedUser).subscribe(data => this.setAdminpasscode(data))
	}

  public setAdminpasscode(data: any) {
    this.adminpasscodemodel = data 
    this.adminpasscodeid = data.AdminPasscodeID
    this.clinicid = data.ClinicID
    this.adminpasscode = data.AdminPasscode
    this.updatedby = data.updatedby
    this.updatedon = data.UpdatedOn
  }

  validateAdminPasscode():boolean
  { 
        if ((this.iSForm.controls.adminpasscode.value == ""  || 
        this.iSForm.controls.adminpasscode.value == null ))
        { 
          this.alertService.clear()
          this.alertService.error('Invalid Passcode')
          return false
        }     
    return true
  }

  updateAdminPasscodeBtnClickEvent(){
    if (this.validateAdminPasscode()){
      this.adminpasscodemodel = new AdminPasscode()
      this.adminpasscodemodel.AdminPasscodeID =  this.adminpasscodeid
      this.adminpasscodemodel.ClinicID =  this.clinicid
      this.adminpasscodemodel.AdminPasscode = this.adminpasscode
      this.adminpasscodemodel.UpdatedBy =  this.loggedUser.UserID
      this.adminpasscodemodel.UpdatedOn = new Date()
      this.passcodeService.updateAdminPasscode(this.adminpasscodemodel, this.loggedUser).subscribe(date =>
      {
        this.alertService.clear()
        this.getAdminpasscode()
        this.alertService.success('Successfully updated')
      },
      error => { 
        this.alertService.clear()
        this.getAdminpasscode()
        this.alertService.error('Error occured while saving data')
          
      });
    }  
  }
//#endregion

//#region super user passcode related methods
getSuperuserpasscode()
{
  this.alertService.clear()
  this.passcodeService.getSuperuserPasscode(this.loggedUser).subscribe(data => this.setSuperuserpasscode(data))
}

public setSuperuserpasscode(data: any) {
  this.superuserpasscodemodel = data 
  this.superuserpasscode = data.SuperuserPasscode
  this.updatedby = data.updatedby
  this.updatedon = data.UpdatedOn
}

validateSuperuserPasscode():boolean
{ 
      if ((this.iSForm.controls.superuserpasscode.value == ""  || 
      this.iSForm.controls.superuserpasscode.value == null ))
      { 
        this.alertService.clear()
        this.alertService.error('Invalid Passcode')
        return false
      }     
  return true
}

updateSuperuserPasscodeBtnClickEvent(){
  if (this.validateSuperuserPasscode()){
    this.superuserpasscodemodel = new SuperuserPasscode()
    this.superuserpasscodemodel.SuperuserPasscode = this.superuserpasscode
    this.superuserpasscodemodel.UpdatedBy =  this.loggedUser.UserID
    this.superuserpasscodemodel.UpdatedOn = new Date()
    this.passcodeService.updateSuperuserPasscode(this.superuserpasscodemodel, this.loggedUser).subscribe(date =>
    {
      this.alertService.clear()
      this.getAdminpasscode()
      this.alertService.success('Successfully updated')
    },
    error => { 
      this.alertService.clear()
      this.getAdminpasscode()
      this.alertService.error('Error occured while saving data')
        
    });
  }  
}
//#endregion
}
